/**
 * @method 用来本地存储和取值删除功能,传一个值是get两个值是set
 * @param {string} key 本地存键key值
 * @param {string} val 存储的值 传null值相当于清除函数
 */
export const cache = (key, val) => {
  if (val || val === null || val === 0) {
    val === null ? localStorage.removeItem(key) : localStorage.setItem(key, val)
  } else {
    return localStorage.getItem(key)
  }
}

/**
 * @method 用来本地存储和取值删除功能,传一个值是get两个值是set，这个是浏览器就没了的储存
 * @param {string} key 本地存键key值
 * @param {string} val 存储的值 传null值相当于清除函数
 */
export const sessionCache = (key, val) => {
  if (val || val === null || val === 0) {
    val === null ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, val)
  } else {
    return sessionStorage.getItem(key)
  }
}

/**
 * @method 用来转化时间戳是时间变成YMDhms自己自由组合的字符串格式
 * @param {number} time 时间戳
 * @param {string} str Y M  D h m s自由组合的字符串随意组合
 */
export const timestampToStr =  (time, str) => {
  if (!time) {
    return ''
  }
  const date = new Date(time)
  str = str.replace('Y', date.getFullYear())
  str = str.replace('M', (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1))
  str = str.replace('D', (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()))
  str = str.replace('h', (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()))
  str = str.replace('m', (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()))
  str = str.replace('s', (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()))
  return str
}

/**
 * @method 用来检测密码是否达标
 * @param {*} val 传入的密码
 */
export const verifyPassword = (val) => {
  console.log(val)
  console.log(typeof val === 'string')

  if (typeof val === 'string') {
    if (val.length > 5) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

/**
 *
 * @param {number} timer 需要转化的时间戳
 */
export const changeTime = (timer) => {
  timer = timer || 0
  let str = ''

  let d = Math.floor(timer / (1000 * 60 * 60 * 24))
  let h = Math.floor((timer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  let m = Math.floor((timer % (1000 * 60 * 60)) / (1000 * 60))
  let s = Math.floor((timer % (1000 * 60)) / 1000)

  let day = d === 0 ? '' : d + '天'
  let hou = h < 10 ? '0' + h : h
  let min = m < 10 ? '0' + m : m
  let sec = s < 10 ? '0' + s : s
  str = day + hou + ':' + min + ':' + sec
  return str
}

/**
 * @method 用来数字变中文数字
 * @param {number} num 需要数字转中文数字的
 * @return {string}  返回中文数字
 */
export const numberChinese = (num) => {
  let str = ''
  switch (num) {
    case 0:  str = '零'
      break
    case 1: str = '一'
      break
    case 2: str = '二'
      break
    case 3: str = '三'
      break
    case 4: str = '四'
      break
    case 5: str = '五'
      break
    case 6: str = '六'
      break
    case 7: str = '七'
      break
    case 8: str = '八'
      break
    case 9: str = '九'
      break
  }
  return str
}
/**
 * 获取年纪编码对应的学段名称
 * @param gradeCode 年纪编码
 * @returns {string} 返回学段名称
 */
export const gradeDes = (gradeCode) => {
  let str = ''
  if (gradeCode) {
    switch (gradeCode) {
      case 1:
      case 2:
      case 3:
        str = '高中'
        break
      case 4:
      case 5:
      case 6:
      case 7:
        str = '初中'
        break
    }
  }
  return str
}
/**
 * 订单状态枚举值转换
 * @param status
 * @returns {string}
 */
export const getOrderStatus = (status) => {
  let str = ''
  if (status) {
    switch (status) {
      case 1:
        str = '未付款'
        break
      case 2:
        str = '已取消'
        break
      case 3:
        str = '已付款'
        break
      case 4:
        str = '退款中'
        break
      case 5:
        str = '已退款'
        break
    }
  }
  return str
}

/**
 * @method 通过文件名字寻找文件格式
 * @param {String} str 文件名
 * @returns {string}
 */
export const fileFormat = (str) => {
  const formatStr = str.split('.').pop() || ''
  if (formatStr === '') return 'unknown'
  const list = {
    excel: ['xls', 'xlsx'],
    pdf: ['pdf'],
    ppt: ['ppt', 'pptx'],
    word: ['doc', 'docx', 'wps'],
    video: ['mov', 'mp4'],
    zip: ['zip', 'rar'],
    music: ['mp3'],
    img: ['png', 'jpg', 'jpge']
  }
  for (let i in list) {
    if (list[i].indexOf(formatStr) > -1) {
      return i
    }
  }
  return 'unknown'
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js